var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 84,
    viewBox: "0 0 79 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M35.0295 2.99951C35.0295 17.0168 34.1554 41.8099 63 42.8612C35.0295 41.5471 35.0295 71.7718 35.0295 78.9995C35.2815 71.9909 35.6854 42.8612 4 42.8612C25.6335 42.8612 32.4076 21.6162 35.0295 2.99951Z",
    stroke: "#6AB4DE",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M52.0266 25.4814L73.6243 8.99951M55.4822 61.6983C61.6736 66.5417 74.445 77.1826 76 80.9995M9.69527 57.361L3 63.867M16.6065 19.8429L9.69527 13.5537",
    stroke: "#6AB4DE",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueStar);
export default __webpack_public_path__ + "static/media/blueStar.38dea76cfb467b082631fa1ecbc1b667.svg";
export { ForwardRef as ReactComponent };